import clsx from 'clsx';
import { LabelText } from 'components/UI/Brand/text';
import loading from 'assets/images/loading-HX_white-bg.gif';
import translate from 'translate';
import styles from './styles.module.scss';

interface ILoadingGifProps {
  text?: string;
  isGrey?: boolean;
  scroll?: boolean;
  dataTestid?: string;
}

const LoadingGif = ({
  text = translate('General_LoadingData'),
  isGrey = false,
  scroll = true,
  dataTestid,
}: ILoadingGifProps) => {
  if (scroll) window.scrollTo(0, 0);
  return (
    <div className={styles.loadingGif} data-testid={dataTestid}>
      <img
        className={styles.image}
        src={loading}
        alt={translate('General_LoadingData')}
      />
      {text && (
        <LabelText
          className={clsx(styles.text, {
            [styles.textGrey]: isGrey,
          })}
        >
          {text}
        </LabelText>
      )}
    </div>
  );
};

export default LoadingGif;
